module.exports = __webpack_public_path__ + "media/images/850/narcolepsy_moon_mountains-11a3af8716228d87d7b6c78ad9d460c4.jpg";